import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import AccountEditModal from 'components/account/AccountEditModal';
import OTextField from 'components/commons/OTextField';
import AccountCreateModal from 'components/account/AccountCreateModal';
import Titlebar from 'components/layouts/Titlebar';
import { Affix, Menu, Icon, Layout, Card, Avatar, Switch, Button, Select, Input, Spin, Collapse} from 'antd';
import ReactTable from "react-table";
import moment from 'moment';
import "react-table/react-table.css";
import { translate  } from 'react-i18next';

const { Option } = Select;
const { Header, Content, Sider } = Layout;
const InputGroup = Input.Group;

class UserList extends Component {
    constructor(props) {
        super(props);
        this.userCrudService = props.userCrudService;
        this.state = {
            currentUser: props.currentUser,
            filtered: { id: 'fullname', value: "" },
            loading: false,
            page: 0,
            pageSize: 10,
            items: 100,
            users: []
        };
    }

    async componentWillMount() {
        this.reloadUserList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentUser) {
            this.setState({ currentUser: nextProps.currentUser });
        }
    }

    async reloadUserList() {
        this.setState({ loading: true });
        const users = await this.userCrudService.listBasicUserDetails();
        this.setState({ users, loading: false });
    }

    changePageSize(value) {
        this.setState({ pageSize: value, page: 0 });
    }

    changePage(step) {
        const isIncrementValid = step > 0 && !this.isNextDisabed();
        const isDecrementValid = step < 0 && !this.isPrevDisabled();

        if (isIncrementValid || isDecrementValid) {
            this.setState({ page: this.state.page + step });
        }
    }

    isNextDisabed() {
        const currentLength = (this.state.page + 1) * this.state.pageSize;
        const usersLength = this.state.users.length;
        return currentLength >= usersLength;
    }

    isPrevDisabled() {
        const currentLength = this.state.page * this.state.pageSize;
        return currentLength <= 0;
    }

    async deleteUser(cellInfo, e) {
        const userId = this.state.users[cellInfo.index]['id'];
        if (this.props.currentUser.id !== userId) {
            this.state.users[cellInfo.index]['delete-loading'] = true;
            this.setState({ users: this.state.users });
            const isSuccessfull = await this.userCrudService.delete(userId);

            if (isSuccessfull) {
                this.reloadUserList();
            } else {
                this.state.users[cellInfo.index]['delete-loading'] = false;
                this.setState({ users: this.state.users });
            }

        }
    }

    async onChange(cellInfo, e) {
        const userId = this.state.users[cellInfo.index]['id'];
        if (this.props.currentUser.id !== userId) {
            const toggledActive = !this.state.users[cellInfo.index]['active'];
            this.state.users[cellInfo.index]['loading'] = true;
            this.setState({ users: this.state.users });
            const isSuccessfull = await this.userCrudService.updateActiveStatus(userId, toggledActive);

            if (isSuccessfull) {
                this.state.users[cellInfo.index]['active'] = toggledActive;
            }
            this.state.users[cellInfo.index]['loading'] = false;
            this.setState({ users: this.state.users });
        }
    }

    onUpdate() {
        this.reloadUserList();
    }

    changeFilter(e) {
        this.setState({ filtered: e });
    }

    render() {
        const {t} = this.props;
        const currentLength = (this.state.page + 1) * this.state.pageSize;
        const usersLength = this.state.users.length;
        return (
            <content>
                <Spin spinning={this.state.loading}>
                    <Titlebar title={t('user.title')} description={t('user.description')}/>
                    <Affix>
                    <Card className="user-list-header">
                    <Row middle="xs" between="xs">
                        <Col xs={4} md={7}>
                            <span className="user-list-pagination">
                                Showing {(currentLength > usersLength) ? usersLength : currentLength} of {usersLength}
                            </span>
                            <Select defaultValue={10} style={{ width: 120 }} value={this.state.pageSize} onChange={this.changePageSize.bind(this)}>
                              <Option value={5}>Show 5</Option>
                              <Option value={10}>Show 10</Option>
                              <Option value={20}>Show 20</Option>
                              <Option value={50}>Show 50</Option>
                            </Select>
                        </Col>
                        <Col xs={8} md={2}>
                            <OTextField container={this.state.filtered} fieldName="value" placeholder="Search..." onUpdate={this.changeFilter.bind(this)}/>
                        </Col>
                        <Col xs={8} md={1}>
                            <Button className="user-list-account" onClick={this.showAccountCreateModal.bind(this)}>
                                Add User
                            </Button>  
                        </Col>
                        <Col xs={4} md={2}>
                         <InputGroup compact>
                            <Button className="user-list-pagination-button prev" onClick={() => this.changePage(-1)} disabled={this.isPrevDisabled()}>Prev</Button>
                            <Button className="user-list-pagination-button next" onClick={() => this.changePage(1)} disabled={this.isNextDisabed()}>Next</Button>
                         </InputGroup>
                        </Col>
                    </Row>
                    </Card>
                    </Affix>
                    <Row>
                        <Col md={12}>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Card width="100%">
                                <ReactTable
                                  pageSize={10 || this.state.users.length}
                                  showPagination={false}
                                  data={this.state.users}
                                  columns={this.columns}
                                  page={this.state.page}
                                  filtered={[this.state.filtered]}
                                  pageSize={this.state.pageSize}
                                  className="user-list"
                                  style={{height: '70vh'}}
                                />
                            </Card>
                            <AccountEditModal ref="accountEditModal" onUpdate={this.onUpdate.bind(this)} currentUser={this.state.currentUser} />
                            <AccountCreateModal ref="accountCreateModal" onUpdate={this.onUpdate.bind(this)} currentUser={this.state.currentUser} />
                        </Col>
                    </Row>
                </Spin>
            </content>
        );
    }

    get columns() {
        const clientHeader = { Header: this.props.t('user.clientName'), accessor: "fullname", filterMethod: this.filterFullName.bind(this) };
        const lastActivityHeader = { Header: this.props.t('user.lastActivity'), accessor: 'lastActivity' };
        const totalBalanceHeader = { Header: this.props.t('user.totalBalance'), accessor: 'revenue' };
        const activeStateHeader = {};
        clientHeader.Cell = this.renderAvatar.bind(this);
        lastActivityHeader.Cell = this.renderActivity.bind(this);
        totalBalanceHeader.Cell = this.renderRevenue.bind(this);
        activeStateHeader.Cell = this.renderActive.bind(this);
        return [clientHeader, lastActivityHeader, totalBalanceHeader, activeStateHeader];
    }

    filterFullName(filter, row) {
        return new RegExp(`.*${filter.value}.*`, "i").test(row.fullname);
    }

    showAccountEditModal(userId) {
        this.refs.accountEditModal.showModal(userId);
    }

    showAccountCreateModal() {
        this.refs.accountCreateModal.showModal();
    }

    renderAvatar(cellInfo) {
        return (
            <div onClick={() => this.showAccountEditModal(this.state.users[cellInfo.index]['id'])}>
                <Row>
                    <Col xs={1}>
                        <span className="user-avatar">
                                <Avatar src={this.state.users[cellInfo.index]['avatar']} icon="user" />
                        </span>
                    </Col>
                    <Col xs={11}>
                        <span className="user-fullname">
                                {this.state.users[cellInfo.index]['fullname']}
                        </span>
                    </Col>
                </Row>


            </div>
        );
    }

    renderActive(cellInfo) {
        return (
            <div className="user-cell">
                <Row>
                    <Col xs={6}>
                        <Switch 
                            checkedChildren="Active" 
                            unCheckedChildren="On Hold" 
                            onChange={this.onChange.bind(this, cellInfo)} 
                            checked={this.state.users[cellInfo.index]['active']} 
                            loading={this.state.users[cellInfo.index]['loading']}/>
                    </Col>
                    <Col xs={6}>
                        <Button type="primary" onClick={this.deleteUser.bind(this, cellInfo)} loading={this.state.users[cellInfo.index]['delete-loading']}>
                            <Icon type="delete" />
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }

    renderActivity(cellInfo) {
        return (
            <div className="user-cell">
                {this.state.users[cellInfo.index]['lastActivity'].format('MM/DD/YY')}
            </div>
        );
    }

    renderRevenue(cellInfo) {
        const revenue = `$${this.state.users[cellInfo.index]['revenue'].toFixed(2)}`;
        return (
            <div className="user-revenue user-cell">
              {revenue}
            </div>
        );
    }
}

export default translate('translations')(UserList);


// WEBPACK FOOTER //
// ./src/components/users/UserList.js